import React from "react";
import MainRoutes from "./Routes/MainRoutes";

function App() {
  return (
    <MainRoutes />
  );
}

export default App;